export default {
  'APP': {
    'logoLink':'https://www.hkma.gov.hk/chi/',
    'tiptitle':[
      '字體大小 100%',
      '字體大小 150%',
      '字體大小 200%',
      '播放驗證碼',
      '刷新驗證碼',
      '關閉',
      '驗證碼',
    ],
    'reminder':[
      '提醒'
    ],
    'title': '香港金融管理局 - 有關銀行產品或服務的投訴表格',
    'pTitle': [
      '第一部分. 投訴人資料',
      '第二部分. 投訴對象',
      '第三部分. 投訴內容',
      '第四部分. 投訴涉及的銀行帳戶或交易的資料',
      '第四部分. 有關投訴的補充資料（例如職員名片、銀行覆函、銀行帳單、產品說明書等。）',
      '投訴人須知',
      '披露個案及個人資料的同意書',
      '無效頁面',
    ],
    'mode': ['普通模式', '色盲模式'],
    'content':{
      // complaint模块里的三段内容
      'complaint':{
        'first':['若擬向香港金融管理局（「金管局」）投訴持牌銀行、有限制牌照銀行或接受存款公司（統稱',
          '「銀行」',
          '），請填妥本網上投訴表格。'
        ],
        'second':['在作出投訴前，請先參閱金管局的',
          '「常見問題（有關銀行產品或服務的投訴）」',
          '及',
          '「處理銀行投訴的流程圖」',
          '，以便了解我們處理投訴的角色及程序。'
        ],
        'third':[
          '此外，我們鼓勵你先向銀行提出正式投訴，讓銀行有機會盡早解決你的投訴。請參閱金管局的',
          '「銀行處理客戶投訴的聯絡人名單」',
          '，當中載有該等專責人員的聯絡資料。'
        ],
        'forth':[
          '你須就金管局代表你處理你的投訴給予所需的同意，因為金管局可能需要為處理你的投訴而向有關銀行或其他第三方披露你向金管局提供的資料（在需要時包括你的個人資料）。'
        ],
        // complaint里的链接
        'link':[
          'https://vpr.hkma.gov.hk/chi/regulatory-resources/registers/register-of-ais-and-lros/',
          'https://www.hkma.gov.hk/chi/smart-consumers/frequently-asked-questions/banking/b/',
          'https://www.hkma.gov.hk/media/chi/doc/other-information/flowchart_on_complaints_chi.pdf',
          'https://www.hkma.gov.hk/media/eng/doc/other-information/Banks_contact_persons.pdf'
        ],
        // 按钮文本
        'btn':[
          '進入'
        ]
      },
      // home模块里的内容
      'home':{
        'left':'（',
        'right':'）',
        'msg':[
          {
            'title':'（1）本人希望金管局考慮及處理本人的投訴。'
          },
          {
            'title':'（2）本人明白及同意，本人提供的所有個案及個人資料，將被用作與處理及/或調查本人的投訴及金管局履行法定職能相關的目的。'
          },
          {
            'title':'（3）本人明白及同意，（i）為與處理及/調查本人的投訴相關的目的；以及（ii）在法律許可或規定下，金管局可將本人提供的個案及個人資料向第三方披露或轉移，包括被投訴的銀行及/或其職員及其他相關監管機構、當局及執法機關。'
          },
          {
            'title':'（4）本人明白，若本人擬要求查閱或更改金管局所持本人的個人資料，本人可以書面方式向金管局法規及打擊清洗黑錢部保障資料主任提出（地址：香港中環金融街8號國際金融中心2期55樓）。金管局可就依從查閱資料的要求收取合理費用。'
          },
          {
            'title':'（5）本人明白，本人無須向金管局提供個案及個人資料，並同意以自願方式作出此舉。若本人提供的個案或個人資料不準確或不完整，可能會影響本人的投訴的處理。'
          }
        ],
        'msg1':[
          {
            'title':'本人希望金管局考慮及處理本人的投訴。'
          },
          {
            'title':'本人明白及同意，本人提供的所有個案及個人資料，將被用作與處理及/或調查本人的投訴及金管局履行法定職能相關的目的。'
          },
          {
            'title':'本人明白及同意，（i）為與處理及/調查本人的投訴相關的目的；以及（ii）在法律許可或規定下，金管局可將本人提供的個案及個人資料向第三方披露或轉移，包括被投訴的銀行及/或其職員及其他相關監管機構、當局及執法機關。'
          },
          {
            'title':'本人明白，若本人擬要求查閱或更改金管局所持本人的個人資料，本人可以書面方式向金管局法規及打擊清洗黑錢部保障資料主任提出（地址：香港中環金融街8號國際金融中心2期55樓）。金管局可就依從查閱資料的要求收取合理費用。'
          },
          {
            'title':'本人明白，本人無須向金管局提供個案及個人資料，並同意以自願方式作出此舉。若本人提供的個案或個人資料不準確或不完整，可能會影響本人的投訴的處理。'
          }
        ],
        // 按钮文本
        'btn':['同意','不同意'],
        // 点击NOT AGREE弹出提示
        'tips':[
          '如你對我們處理個人資料有任何疑問，請以電郵與我們聯絡(',
          'bankcomplaints@hkma.gov.hk',
          ')。'
        ]
      },
      // note模块里的内容
      'note':{
        'msg1':[
          {
            'title': '本表格共有4個部份。你可按「下一步」按鈕進入下一部份或「上一步」按鈕返回上一部份。'
          },
          {
            'title': '如果你想暫時儲存已輸入的資料以便於稍後時間繼續填寫表格，請按該部份下方的「儲存」按鈕。你可利用這功能將資料儲存到電腦的臨時檔案，該檔案會被加密及以密碼保護，但已上載的附件將不會被儲存。有關臨時檔案將於7天後失效。'
          },
          {
            'title': '你可按下方的「載入已輸入的資料」按鈕，並從你的電腦中上載之前儲存的臨時檔案及輸入所需密碼，以繼續進行輸入程序。'
          },
          {
            'title': '你可在本表格的最後一部份上載補充資料，每個檔案不可大於10MB，每份投訴表格最多可上載10個檔案。如需提供額外資料，你可透過電郵或郵件遞交給我們。當你成功提交投訴表格後，系統會提供一個參考編號給你，請你在電郵或郵件中註明此編號。'
          }
        ],
        'msg2':[
          {'title':'你的電腦須符合以下設定：'},
          {'title':'瀏覽器：Google Chrome/Internet Explorer 9 或以上/Safari 5'},
          {'title':'解像度：1024 x 768'},
          {'title':'私隱級別：中等'},
          {'title':'如果你在載入投訴表格時遇到困難，請將安全級別更改至低或接受所有cookies。'},
        ],
        'msg21':[
          {'title':'5. 你的電腦須符合以下設定：'},
          {'title':' - 瀏覽器：Google Chrome/Internet Explorer 9 或以上/Safari 5'},
          {'title':' - 解像度：1024 x 768'},
          {'title':' - 私隱級別：中等'},
          {'title':' - 如果你在載入投訴表格時遇到困難，請將安全級別更改至低或接受所有cookies。'},
        ],
        'msg3':[
          {'title':'基於安全考慮，請勿使用公共電腦。'},
          {'title':'如需協助，請於辦公時間內致電2878'},
          {'title':'1378。所有你和本局職員之間的電話談話內容，無論是你的來電或我們的回覆電話，都可能會被錄音以確保我們的服務質素。'}
        ],
        // 按钮的文本
        'btn':['提出新投訴','載入已輸入的資料'],
        // Lodge a new complaint按钮的文本
        'lodge':[
          '請輸入以下驗證碼。',
          '輸入驗證碼',
          '完成',
          '驗證碼錯誤，請輸入上圖中的驗證碼。'
        ],
        // Resume previous completion process按钮的文本
        'resume':{
          'header':['第一步、請選擇臨時檔案。','選擇文件'],
          'main':[
            '第二步、請輸入密碼。',
            '第三步、請輸入以下驗證碼。',
            '完成',
            '請輸入早前提供給你的6位數字密碼。',
            '請選擇已儲存的臨時檔案。',
            '只接受HKMA格式的檔案（*.hkma）。',
            '驗證碼或密碼輸入錯誤。',
            '請輸入以HKMAbankcomplaint開頭的文件。',
            '文件保存超過七天，無法恢復。',
            '你上載的臨時檔案/密碼/驗證碼並不正確，請重新輸入。',
            '恢復投訴單，傳入的文件是空。',
            '密碼錯誤。',
            '檔案已失效。',
          ]
        }
      },
      //必填项改成这种提示625
      'mandatory':'此欄必須填寫',
      // 公共部分
      'part':{
        'dialogTip':'你的資料將會儲存到電腦的臨時檔案。',
        // 按钮组
        'btngroup':['上一步','儲存','下一步','預覽','提交','退出'],
        // 保存按钮的文本
        'savebtn':['你的資料將會被儲存到你的電腦，你可在7天內開啟已儲存的檔案以繼續填寫表格。已上載的附件將不會被儲存，你需在恢復填寫表格時重新上載附件。'],
        // 保存文件时弹出的弹框的文本
        'popout':['請保存以下密碼，以便開啟已儲存的臨時檔案。', '提示: 你尚未完成此投訴表格。你需在7日內填妥此表格的所有部份並遞交表格。'],
        //下拉框
        'select':'選項',
        //For Exit Prompt
        'exitPrompt' : [
          '你確定離開此頁?',
          '離開',
          '取消'
        ],
        //For Skip Ahead
        'skipAhead' : [
          '請先完成前面的部分。',
        ],
        //For Menu Aria-Label and Alt Text
        'menu' : [
          '步驟',
          '已完成',
          '尚未完成',
          '正在填寫'
        ],
        // 提示
        'tips':[
          '此欄必須填寫',
          '必填4位（字母或數字）',
          '請輸入有效的電郵地址',
          '請輸入姓氏',
          '請輸入電話號碼',
          '請選擇地址類型',
          '與上述電郵地址不相同。請重新輸入。',
        ],
        // 性别,点击选择框后的内容
        'genderList': [{
          'label': '選項',
          'value': ' '
         },{
          'label': '先生',
          'value': 'MR'
         },{
          'label': '太太',
          'value': 'MRS'
         },{
          'label': '女士',
          'value': 'MS'
         },{
          'label': '不適用',
          'value': 'NA'
         }
        ],
        'addressList':[{
          'label':'寄回 - 通訊地址',
          'value':'1'
        },{
          'label':'通過電郵 - 電郵地址',
          'value':'2'
        }]
      },
      // part1模块里的内容
      'part1':{
        'title':['1. 投訴人資料'],
        // 表单内容
        'form':{
          'content':[
            '投訴是由個人或公司客戶提出？',
            '個人',
            '公司'
          ],
          // 页面中相同的文本
          'common':{
            'method':[
              '郵寄',
              '電郵',
              '填寫最少一項',
              '請填寫通訊地址',
              '請提供相應的通訊地址及/或電郵地址。',
              '請提供相應的通訊地址及/或電郵地址。',
            ],
            'text':[
              '姓氏',
              '名字',
              '身份證明文件號碼（首4個數字）',
              '通訊地址',
              '電郵地址',
              '電話號碼',
              '你是否需要委任代表就你的投訴提交資料及查詢進度？',
              '是',
              '否',
              '此欄必須填寫',
              '請填寫通訊地址及/或電郵。',
              '請填寫必填項目。',
              '請輸入姓氏',
              '請選擇稱呼',
              '請選擇證件類型',
              '請輸入名字',
              '與金管局的通訊方式',
              '（一般而言，本局的覆函會直接發給投訴人。）',
              '請再次輸入電郵地址',
            ],
            // 证件类型,点击选择框后的内容
            'identityList': [
              {
              'label': '選項',
              'value': ' '
             },
             {
              'label': '香港身份證',
              'value': 'HKID'
             },{
              'label': '護照',
              'value': 'PASSPORT'
             },{
              'label': '旅遊證件',
              'value': 'TRAVEL'
            }],
            // 地址是否相同
            'sameAddress': '和投訴人相同'
          },
          // 点击Individual按钮后的内容
          'individual':['投訴人姓名'],
          // 点击Corporate按钮后的内容
          'corporate':{
            'text':[
              '公司名稱',
              '公司獲授權代表',
              '（即董事/獲授權簽署人）',
              '公司是在哪一年成立的？',
              '公司是否在香港註冊？',
              '公司主要經營什麼業務？',
              '請輸入公司名字',
              '請輸入公司成立的時間',
              '請輸入公司經營的業務',
              '年份格式範例: YYYY',
              '請輸入正確的年份格式: YYYY',
            ]
          },
          // 委派代表的信息
          'delegate':['獲委任代表的姓名','添加代表'],
          // 符号的解释
          'explain':['必須填寫','填寫最少一項'],
          // 填写代表的个数限制的弹框文本
          'representativenum':['不能添加超過2個代表。'],
          "complaintAgain":'你曾否向金管局作出與這宗個案有關的投訴？',
          "complaintNum":'投訴編號（如有）',
          "fieldError" : [
            "請填寫必填項目。",
            "請填寫必填項目。",
            "請檢查 '交易日期'",
            "請檢查 '爭議金額'",
          ]
        }
      },
      // part2模块里的内容
      'part2':{
        'title':['2. 投訴對象'],
        'form':{
          'bankname':['銀行名稱'],
          // 銀行文案
          'bankText': {
            'name':'銀行名稱',
            'same':'同上',
            'branch':'分行 / 部門',
            'staff':'職員姓名',
            'sure':'姓氏',
            'first':'名字',
            'job':'職銜',
            'hkma':'金管局註冊號碼（如適用）',
            'have':'有否向有關銀行投訴？',
            'y':'有',
            'n':'沒有',
            'number':'銀行的投訴個案編號',
            'date':'向銀行提出投訴的日期：',
            'ifStaff':'投訴是否涉及銀行職員？',
            'ifAccount':'投訴是否涉及銀行帳戶或交易？',
          },
          'explain':['必須填寫'],
          'clickbox':['添加銀行','添加銀行職員'],
          'popout':'不能添加超過3個銀行',
          'tips':[
            '請輸入正確的日期格式（DD/MM/YYYY，DD/MM/YYYY，...）',
            '請輸入分行或部門',
            '請輸入職稱',
            '請輸入金管局登記號碼',
            '輸入的日期中存在相同的日期',
            '日期格式範例：DD/MM/YYYY，DD/MM/YYYY，...',
            '請輸入銀行名稱',
            '請輸入投訴是否涉及銀行職員？',
            '請輸入投訴是否涉及銀行帳戶或交易？',
            '請輸入投訴有否向有關銀行投訴？',
          ],
          'lodgedWithBank' : [
            '我們鼓勵你先向銀行提出正式投訴，讓銀行有機會盡早解決你的投訴。請參閱金管局的「',
            '銀行處理客戶投訴的聯絡人名單',
            '」，當中載有該等專責人員的聯絡資料。',
          ],
          'dropdownLabel' : [
            '爭議類型',
            '貨幣',
          ]
        }
      },
      // part3模块里的内容
      'part3':[
        '3. 投訴內容',
        '請逐項具體說明所有不滿事項：',
        '添加項目',
        '請描述導致今次投訴的事件（按時間先後次序）。 ',
        '不能添加超過10行',
        '請提供所有不滿事項及/或導致今次投訴的事件。'
      ],
      // part4模块里的内容
      'part4':{
        'title':['4. 投訴涉及的銀行帳戶或交易的資料'],
        'subtitle':['請提供投訴所涉及的帳戶或交易詳情：'],
        // 账户类型
        'accounttype':[
          '戶口類型',
          '個人戶口',
          '聯名戶口',
          '公司戶口'
        ],
        // 点击sole account和joint account按钮显示的内容
        'account':[
          '戶口號碼',
          '戶口持有人姓名/名稱',
          '姓氏',
          '名字',
          '產品名稱',
          '交易日期',
          '爭議金額',
          '交易日期',
          '交易月份',
          '交易年份',
        ],
        // 爭議類型
        'disputedtype': [
          {
            'label': '選項',
            'value': ''
          },
          {
            'label': '交易金額',
            'value': 'TRANSACTION'
          },
          {
            'label': '虧損',
            'value': 'LOSS'
          },
          {
            'label': '利息',
            'value': 'INTEREST'
          },
          {
            'label': '費用',
            'value': 'FEE'
          },
        ],
        // 幣種
        'currencytype':[
          {
            'label': '選項',
            'value': ''
          },
          {
            'label':'港元(HKD)',
            'value':'HKD'
          },
          {
            'label':'美元(USD)',
            'value':'USD'
          },
          {
            'label':'人民幣(RMB)',
            'value':'RMB'
          },
          {
            'label':'英鎊(GBP)',
            'value':'GBP'
          },
          {
            'label':'日圓(JPY)',
            'value':'JPY'
          },
          {
            'label':'歐羅(EUR)',
            'value':'EUR'
          },
          {
            'label':'瑞士法郎(CHF)',
            'value':'CHF'
          },
          {
            'label':'澳元(AUD)',
            'value':'AUD'
          },
          {
            'label':'加拿大元(CAD)',
            'value':'CAD'
          },
          {
            'label':'紐西蘭元(NZD)',
            'value':'NZD'
          },
          {
            'label':'泰珠(THB)',
            'value':'THB'
          },
          {
            'label':'新加坡元(SGD)',
            'value':'SGD'
          },
          {
            'label':'瑞典克郎(SEK)',
            'value':'SEK'
          },
          {
            'label':'丹麥克郎(DKK)',
            'value':'DKK'
          },
          {
            'label':'其他(Others)',
            'value':'Others'
          }
        ],
        // 添加框
        'addbox':['添加戶口/交易','添加戶口持有人','添加戶口','添加交易'],
        // 争议金额
        'amountTip':'最多15位數字和4位小數',
        // 日期提示
        'dateTip':'日期格式不正確',
        // 弹框
        'popout':[
          '不能添加超過3個帳戶持有人。',
          '不能添加超過10個帳戶/交易。'
        ],
        'tips':[
          '請輸入帳戶號碼',
          '請輸入產品名稱',
          '請輸入2位數字的日期，如01、10等',
          '請輸入2位數字的月份，如01、10等',
          '請輸入4位數字的年份，如2019等',
        ]
      },
      // part5模块里的内容
      'part5':{
        'title':['4. 有關投訴的補充資料（例如職員名片、銀行覆函、銀行帳單、產品說明書等）'],
        'doc':['添加檔案'],
        'del':'刪除',
        'upload':'上傳中...',
        'memo':[
          '每個檔案不可大於10MB。每份投訴表格最多可上載10個檔案。檔案格式只限於GIF，JPG，JPEG，PNG，TIFF，TIF，PDF。',
          '如檔案大小超過上限或以其他格式儲存，請電郵（',
          '）或郵寄至本局（香港中環金融街8號國際金融中心2期55樓香港金融管理局投訴處理中心）。'
        ],
        'attention':[
          '注意事項',
          '檔案上傳失敗。請電郵或郵寄至本局。'
        ],
        'prompt':[
          '不能添加超過10個文檔。',
          '檔案格式只限於GIF，JPG，JPEG，PNG，TIFF，TIF，PDF。',
          '不可以上傳相同文件'
        ]
      },
      //PREVIEW模块的内容
      'preview':[
        '預覽',
        '更改',
        '我現遞交本表格，並確認及同意下列事項：',
        '香港中環金融街8號',
        '電話：2878 1378',
        '國際金融中心2期55樓',
        '傳真：2509 3990',
        '香港金融管理局',
        '電郵地址：',
        ' 所有你和本局職員之間的電話談話內容，無論是你的來電或我們的回覆電話，都可能會被錄音以確保我們的服務質素。',
        '投訴處理中心',
        '部分',
        '目錄'
      ],
      //SUBMIT模块的内容
      'submit':[
        '你已遞交投訴表格',
        '你的參考編號是',
        '如你要提交補充資料，請電郵（',
        '列印',
        '儲存列印版本',
        '退出',
        '）或郵寄至本局（香港中環金融街8號國際金融中心2期55樓香港金融管理局投訴處理中心）。請在函件中註明以上參考編號。',
        '正在處理...',
        '你確定要退出本頁嗎？退出後將無法列印或儲存表格。',
        '確認',
        '取消',
        '請儲存此投訴表格的列印版本作紀錄。',
      ],
      'submitDate':'遞交日期',
      //wrongPage的内容
      'wrongPage':{
        'tips':[
          "抱歉，您不能直接進入此頁面。",
          '請返回',
          '主頁',
          '。',
        ]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/Language/complex.js